var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.characterProblem
        ? _c(
            "v-layout",
            { attrs: { column: "" } },
            [
              _vm.breadcrumbs.length
                ? _c(
                    "v-breadcrumbs",
                    { attrs: { items: _vm.breadcrumbs } },
                    [
                      _c(
                        "template",
                        { slot: "divider" },
                        [_c("v-icon", [_vm._v("chevron_right")])],
                        1
                      )
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "v-layout",
                { attrs: { row: "" } },
                [
                  _c(
                    "v-avatar",
                    {
                      staticClass: "mr-3",
                      attrs: { color: _vm.avatarColor, size: "50" }
                    },
                    [
                      _c("img", {
                        staticStyle: { width: "40px", height: "40px" },
                        attrs: { src: _vm.characterProblem.picto }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    [
                      _c("h1", { staticClass: "primary--text" }, [
                        _vm._v(_vm._s(_vm.characterProblem.name))
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { attrs: { xs3: "" } },
                        [
                          _c("v-card", {
                            attrs: {
                              flat: "",
                              color: "greyDark",
                              height: "1px",
                              width: "100%"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("span", {
                        staticClass: "object-title primary--text mt-2",
                        staticStyle: {
                          "font-size": "16px",
                          "font-weight": "500"
                        },
                        domProps: { innerHTML: _vm._s(_vm.levelFormatted) }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.$route.meta["manage_agency_char_pb"]
                    ? _c(
                        "v-flex",
                        {
                          staticClass: "actions-menu__wrapper",
                          attrs: {
                            xs3: "",
                            "mt-0": "",
                            "pt-0": "",
                            "text-xs-right": ""
                          }
                        },
                        [
                          _c("crud-menu", {
                            key: "char_pb_menu",
                            attrs: {
                              texts: _vm.coMenuTexts,
                              auths: _vm.coMenuAuths
                            },
                            on: {
                              edit: _vm.handleMenuEdit,
                              delete: _vm.handleMenuDelete
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _vm.characterProblem.level === 1 &&
              _vm.$route.meta["char_pb_linked"] &&
              _vm.characterProblem.level_2.length
                ? _c(
                    "div",
                    [
                      _c(
                        "v-flex",
                        { attrs: { xs5: "", "pl-2": "", "mt-4": "" } },
                        [
                          _c("h1", { staticClass: "primary--text" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t(_vm.lblSetting.amCharPbLevel2Simple)
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs2: "" } },
                            [
                              _c("v-card", {
                                attrs: {
                                  flat: "",
                                  color: "greyDark",
                                  height: "1px",
                                  width: "100%"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-card",
                        {
                          staticClass: "py-3 mt-3",
                          class: { "grey--text": _vm.characterProblem.disable }
                        },
                        [
                          _c(
                            "v-layout",
                            { attrs: { row: "", wrap: "" } },
                            _vm._l(_vm.characterProblem.level_2, function(
                              item
                            ) {
                              return _c(
                                "v-flex",
                                {
                                  key: item.id,
                                  staticClass: "pa-4",
                                  attrs: { xs2: "" }
                                },
                                [
                                  _c(
                                    "router-link",
                                    {
                                      staticStyle: {
                                        "text-decoration": "none",
                                        color: "black"
                                      },
                                      attrs: {
                                        to: "/profile/char-problem/" + item.id
                                      }
                                    },
                                    [
                                      _c(
                                        "v-layout",
                                        {
                                          attrs: {
                                            column: "",
                                            "align-center": ""
                                          }
                                        },
                                        [
                                          _c(
                                            "v-avatar",
                                            {
                                              attrs: {
                                                size: "60",
                                                color: _vm.level2Color(item)
                                              }
                                            },
                                            [
                                              _c("img", {
                                                staticClass: "pa-1",
                                                attrs: { src: item.picto }
                                              })
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "mt-2",
                                              staticStyle: {
                                                "text-align": "center"
                                              }
                                            },
                                            [
                                              _c("b", [
                                                _vm._v(_vm._s(item.name))
                                              ])
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { xs5: "", "pl-2": "", "mt-4": "" } },
                [
                  _c("h1", { staticClass: "primary--text" }, [
                    _vm._v(_vm._s(_vm.$t(_vm.lblSetting.amAttributes)))
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { xs2: "" } },
                    [
                      _c("v-card", {
                        attrs: {
                          flat: "",
                          color: "greyDark",
                          height: "1px",
                          width: "100%"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card",
                { staticClass: "py-3 mt-3" },
                [
                  _vm.$route.meta["view_char_pb_2_attribute"]
                    ? _c(
                        "v-layout",
                        {
                          attrs: { "pr-1": "", "pl-4": "", row: "", wrap: "" }
                        },
                        _vm._l(_vm.characterProblem.attributes, function(item) {
                          return _c(
                            "v-flex",
                            { key: item.id, attrs: { xs4: "", "px-3": "" } },
                            [
                              _c("v-hover", {
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function(ref) {
                                      var hover = ref.hover
                                      return _c(
                                        "v-layout",
                                        { attrs: { column: "" } },
                                        [
                                          _c(
                                            "strong",
                                            { staticClass: "black--text" },
                                            [_vm._v(_vm._s(item.name))]
                                          ),
                                          _vm._v(" "),
                                          item.unit
                                            ? _c("v-layout", [
                                                _c("label", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        _vm.lblSetting
                                                          .amAttributeUnit
                                                      ) + " :"
                                                    )
                                                  )
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "strong",
                                                  { staticClass: "ml-1" },
                                                  [_vm._v(_vm._s(item.unit))]
                                                )
                                              ])
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c("v-layout", [
                                            _c("label", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    _vm.lblSetting
                                                      .amAttributeType
                                                  ) + " :"
                                                )
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "strong",
                                              { staticClass: "ml-1" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    item.attribute_type.name
                                                  )
                                                )
                                              ]
                                            )
                                          ]),
                                          _vm._v(" "),
                                          item.fk_attribute_type == 1 ||
                                          item.fk_attribute_type == 4
                                            ? _c("v-layout", [
                                                _c("label", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        _vm.lblSetting
                                                          .amAttributeIsCalculable
                                                      ) + " :"
                                                    )
                                                  )
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "strong",
                                                  { staticClass: "ml-1" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        item.used_by_maintenance
                                                          ? _vm.$t(
                                                              _vm.lblSetting
                                                                .amCalculableTrue
                                                            )
                                                          : _vm.$t(
                                                              _vm.lblSetting
                                                                .amCalculableFalse
                                                            )
                                                      )
                                                    )
                                                  ]
                                                )
                                              ])
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c(
                                            "v-flex",
                                            { attrs: { "text-xs-left": "" } },
                                            [
                                              hover &&
                                              _vm.$route.meta[
                                                "manage_char_pb_2_attribute"
                                              ]
                                                ? _c(
                                                    "v-btn",
                                                    {
                                                      attrs: {
                                                        color: "primary",
                                                        small: "",
                                                        flat: ""
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          _vm.handleEditAttribute(
                                                            item
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "v-icon",
                                                        {
                                                          staticClass: "mr-1",
                                                          attrs: { small: "" }
                                                        },
                                                        [_vm._v("edit")]
                                                      ),
                                                      _vm._v(
                                                        "\n                Modifier\n              "
                                                      )
                                                    ],
                                                    1
                                                  )
                                                : _c("div", {
                                                    staticStyle: {
                                                      height: "40px"
                                                    }
                                                  })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    }
                                  }
                                ])
                              })
                            ],
                            1
                          )
                        }),
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.$route.meta["manage_char_pb_2_attribute"]
                    ? _c(
                        "div",
                        { staticClass: "text-md-center" },
                        [
                          _c("base-modal-submit-btn", {
                            attrs: {
                              title: _vm.$t(
                                _vm.lblSetting.amCreateAttributeTitle
                              ),
                              disabled: !_vm.characterProblem
                                .agency_character_problem.enabled,
                              icon: "add"
                            },
                            on: { record: _vm.handleAddAttribute }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.dtMessageErrorModel
        ? _c("base-error-dialog", {
            attrs: { error: _vm.dtError },
            on: { cancel: _vm.handleCloseErrorModal }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.dtDeleteCharPb
        ? _c("base-delete-dialog", {
            attrs: {
              "is-loading": _vm.dtIsLoading,
              message: _vm.coDeleteMessage
            },
            on: {
              cancel: _vm.handleDeleteCancel,
              delete: _vm.confirmDeleteCharPb
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7de54e8a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7de54e8a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/containers/profile/char-problem-detail/template.html
// module id = null
// module chunks = 